var React = require('react');

function CurrentLocation (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9.26973","cy":"10.4257","r":"6.3005","stroke":"#4F4C4D","key":0}),React.createElement("rect",{"x":"12.8496","y":"9.57486","width":"5.52307","height":"1.25184","rx":"0.625922","fill":"#4F4C4D","key":1}),React.createElement("rect",{"y":"9.57486","width":"5.52307","height":"1.25184","rx":"0.625922","fill":"#4F4C4D","key":2}),React.createElement("rect",{"x":"9.896","y":"14.4647","width":"5.52307","height":"1.25184","rx":"0.625922","transform":"rotate(90 9.896 14.4647)","fill":"#4F4C4D","key":3}),React.createElement("rect",{"x":"9.896","y":"0.863708","width":"5.52307","height":"1.25184","rx":"0.625922","transform":"rotate(90 9.896 0.863708)","fill":"#4F4C4D","key":4})]);
}

CurrentLocation.defaultProps = {"width":"19","height":"20","viewBox":"0 0 19 20","fill":"none"};

module.exports = CurrentLocation;

CurrentLocation.default = CurrentLocation;
